/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the VivaLiteScanApiConfiguration configuration object with a given root URL.
 */
export function provideVivaLiteScanApiConfiguration(rootUrl: string) {
  var config = new VivaLiteScanApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: VivaLiteScanApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class VivaLiteScanApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `VivaLiteScanModule.forRoot()`
 */
export interface VivaLiteScanApiConfigurationParams {
  rootUrl?: string;
}
